import controller from './threshold-builder.controller';

const template = require('./threshold-builder.html');

export default {
    controller,
    template,
    bindings: {
        trigger: '<',
        triggerDelay: '<',
        unacknowledgesAfter: '<',
        reminderNotifications: '<',
        resolvedNotifications: '<',
        onTriggerChange: '&',
        onDelayChange: '&',
        onAckChange: '&',
        onNotificationsChange: '&',
        onFieldChange: '&',
    }
};
